<template>
    <v-card :href="href" tile class="gate__link" :class="{ 'gate__link--nolink': noLink }" elevation="0">
        <div class="gate__link-thumb" :style="'background-image: url('+bgImage+')'">
            <div class="gate__link-thumb__inner">
                <h4 class="tit--sm white--text line-height-12 mb-10 mb-lg-14">
                    {{tit}}
                </h4>
                <p class="page-text white--text font-weight-bold py-4 py-lg-10" v-if="noLink">
                    준비중입니다.
                </p>
                <v-btn v-else tile outlined color="white" class="w-100px w-lg-120px"><span class="page-text font-weight-bold">바로가기</span></v-btn>
            </div>
        </div>
    </v-card>
</template>

<script>

export default{
    props : {
        href : {type :String, default : ""},
        tit : {type :String, default : ""},
        bgImage : {type :String, default : ""},
        noLink: { type: Boolean, default: false },
    },
	components: {

	},
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>

<style scoped>
.gate__link-thumb{
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
}
.gate__link-thumb:not(.gate__link--nolink .gate__link-thumb)::before{
    content: "";
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 0;
    top: 0;
    left: 0;
    background-color: rgba(46, 96, 239, 0.8);
    opacity: 0;
    visibility: hidden;
    transition: 0.15s ease-out;
}
.gate__link--nolink .gate__link-thumb::after{
    content: "";
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
.gate__link-thumb__inner{
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .gate__link:hover .gate__link-thumb:not(.gate__link--nolink .gate__link-thumb)::before{
        opacity: 1;
        visibility: visible;
    }
}
@media (min-width:1200px){
}
</style>